import { render } from "./RelatorioConsultasLoja.vue?vue&type=template&id=79efe8e4&scoped=true&ts=true"
import script from "./RelatorioConsultasLoja.vue?vue&type=script&lang=ts"
export * from "./RelatorioConsultasLoja.vue?vue&type=script&lang=ts"

import "./RelatorioConsultasLoja.vue?vue&type=style&index=0&id=79efe8e4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79efe8e4"]])

export default __exports__